import { render, staticRenderFns } from "./IndexInfo.vue?vue&type=template&id=f1256906&scoped=true"
import script from "./IndexInfo.vue?vue&type=script&lang=js"
export * from "./IndexInfo.vue?vue&type=script&lang=js"
import style0 from "./IndexInfo.vue?vue&type=style&index=0&id=f1256906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1256906",
  null
  
)

export default component.exports